import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Heading, Text } from '@makemydeal/dr-ui-bricks-components';

import { SHARE_CREDIT_APP_QR_CODE_CONTENT, SHARE_CREDIT_APP_QR_CODE_SIZE } from './constants';
import { ShareCreditAppQrCodeContent, ShareCreditAppQrCodeImage, ShareCreditAppQrCodeRoot } from './shareCreditAppQrCode.style';

// qrcode.react renders the QR as inline SVG synchronously inside React. dr-services-pdf instead uses `qrcode` (QRCode.toDataURL) server-side to produce a base64 image for PDFs.
export const ShareCreditAppQrCode: React.FC<{ buyerFirstName: string; link: string }> = ({ buyerFirstName, link }) => (
    <ShareCreditAppQrCodeRoot data-testid="share-credit-app-qr-code">
        {link && (
            <ShareCreditAppQrCodeImage data-testid="share-credit-app-qr-code-image">
                <QRCodeSVG
                    value={link}
                    size={SHARE_CREDIT_APP_QR_CODE_SIZE}
                    level="M"
                    includeMargin={false}
                    fgColor="currentColor"
                    bgColor="#ffffff"
                    role="img"
                    aria-label={SHARE_CREDIT_APP_QR_CODE_CONTENT.imageLabel}
                />
            </ShareCreditAppQrCodeImage>
        )}
        <ShareCreditAppQrCodeContent>
            <Heading as="h3" level={6} weight="regular">
                {SHARE_CREDIT_APP_QR_CODE_CONTENT.heading}
            </Heading>
            <Text size="xsmall">
                {link
                    ? SHARE_CREDIT_APP_QR_CODE_CONTENT.description(buyerFirstName)
                    : SHARE_CREDIT_APP_QR_CODE_CONTENT.unavailableMessage}
            </Text>
        </ShareCreditAppQrCodeContent>
    </ShareCreditAppQrCodeRoot>
);
